<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WkeHtX/tc-custom/9781607106739.jpg?1738726231348" alt="This image is the cover for the book Uncle John's Bathroom Reader: WISE UP!, Uncle John's Bathroom Reader"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uncle John's Bathroom Reader: WISE UP!, Uncle John's Bathroom Reader
      </h1>
      <p class="bookDescription body article font2">
        <b>With this volume filled with thousands of bizarrely fascinating facts, we’re on a roll!</b><br/>  <br/> Is there any other single book in the universe with this many awesome tidbits of bite-sized information? Nope. And that’s a fact! At nearly 400 pages (with a handy index for your fact-seeking convenience), <i>Wise Up!</i> is a must-have for anyone who likes their information on the go. It’s organized into hundreds of topics—everything from sports and entertainment to word origins and science. Here are but a few of the facts awaiting you:<br/>  <br/> * More women than men talk to their cars.<br/> * The melody for Nat King Cole’s 1954 hit “Smile” was composed by Charlie Chaplin.<br/> * Acid rain was first identified and named in 1852.<br/> * What is your buccal cavity? Your mouth.<br/> * There are no skunks in Newfoundland.<br/> * The average Super Bowl party has 18 people.<br/> * When dropped in water, a fresh egg will sink; a stale one won’t.<br/> * The average newborn baby spends 113 minutes a day crying.<br/> * Pepper was so valuable during Elizabethan times that it was sold by the grain.<br/> * Fossilized termite farts have been preserved in amber. And thousands more! 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bathroom Readers' Institute
      </h2>
      
      <p class="authorDescription body article">The Bathroom Readers' Institute is a tight-knit group of loyal and skilled writers, researchers, and editors who have been working as a team for years. The BRI understands the habits of a very special market—Throne Sitters—and devotes itself to providing amazing facts and conversation pieces.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Portable Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c704746